
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
  open(type: number) {
    if (type === 2) {
      location.href =
        'https://mp.weixin.qq.com/mp/homepage?__biz=MzY4NzMzMjYyMw==&hid=2&sn=6bda6cbbcc6ae08ebfa392e6e622420c';
    } else {
      this.$toast('内容更新中');
    }
  }
}
